<div class="product-wrapper row justify-content-start">
  <div class="col-12 col-md-6 mb-2">
    <div class="product-box">
      <div class="info-box">
        <div class="product-wrapper">
          <div class="row no-gutters price-label">
            <div class="col-12">
              <div class="singleFund col-12">
                <div class="w-99 product-wrapper">
                  <kendo-dropdownlist
                    [formControl]="fundId"
                    [data]="currentUser?.marginTradeDetails"
                    [valuePrimitive]="false"
                    [valueField]="'customerCode'"
                    textField="customerName"
                    tabindex="1"
                    [popupSettings]="{ height: 200, 'z-index': 1000 }"
                  >
                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                      <span class="template">{{ dataItem?.customerName }} [{{ dataItem?.customerCode }}]</span>
                      <span class="signed-acc-types">
                        <i class="far joint fa-handshake" [hidden]="dataItem.index === 0"></i>
                        <i class="ind fas fa-user-tie" [hidden]="dataItem.index !== 0"></i>
                      </span>
                    </ng-template>
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      <span class="template"> {{ dataItem?.customerName }} [{{ dataItem?.customerCode }}] </span>
                      <span class="signed-acc-types">
                        <i class="far joint fa-handshake" [hidden]="dataItem.index === 0"></i>
                        <i class="ind fas fa-user-tie" [hidden]="dataItem.index !== 0"></i>
                      </span>
                    </ng-template>
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 mb-2">
    <div class="product-box">
      <div class="info-box">
        <div class="product-wrapper">
          <div class="row no-gutters ledger-info">
            <div class="col-12 pt-2 pb-3">
              <b>Balance</b>
              <span
                ><b>BDT {{ (portfolioData?.marketValueTotal && (portfolioData?.marketValueTotal | money)) || '0.00' }}</b></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 col-md-11 mb-2 mt-2">
    <ul class="sub-nav">
      <li [routerLinkActive]="['active']" [routerLink]="'/dashboard/margin-trading/portfolio/' + investerCode" routerLinkActive="active">
        <span>Portfolio</span>
      </li>

      <li [routerLinkActive]="['active']" [routerLink]="'/dashboard/margin-trading/summary/' + investerCode" routerLinkActive="active">
        <span>Summary</span>
      </li>
    </ul>
  </div>
</div>
<div class="card-1">
  <div [hidden]="!dataInProgress" class="loader text-center"></div>
  <div id="gridComponent" class="grid-container" *ngIf="portfolioPageGrid">
    <div class="grid-message p-a" [hidden]="portfolioPageGrid && portfolioPageGrid.total">
      <div [hidden]="!calsPortfolioGridInProgress" class="loader">loader</div>
      <p [hidden]="calsPortfolioGridInProgress">No Records Found.</p>
    </div>
    <div *ngIf="portfolioPageGrid?.dataSource?.data?.length > 0">
      <table mat-table [dataSource]="portfolioPageGrid.dataSource" matSort class="mat-elevation-z1 mat-table mat-small clean-table">
        <!-- Instrument Code -->
        <ng-container matColumnDef="instrumentCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Instrument Code</th>
          <td mat-cell *matCellDef="let dataItem">
            <div style="white-space: nowrap" class="text-left">
              <span>{{ dataItem.instrumentCode }}</span>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Total Qty -->
        <ng-container matColumnDef="totalStock">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Total Qty</th>
          <td mat-cell *matCellDef="let dataItem" class="text-end">
            <div style="white-space: nowrap">
              <span>{{ dataItem.totalStock | number : 0 : false }}</span>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Saleable Qty -->
        <ng-container matColumnDef="saleable">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Saleable Qty</th>
          <td mat-cell *matCellDef="let dataItem" class="text-end">
            <div style="white-space: nowrap">
              <span>{{ dataItem.saleable | number : 0 : false }}</span>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Average Cost -->
        <ng-container matColumnDef="avgCost">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Average Cost</th>
          <td mat-cell *matCellDef="let dataItem" class="text-end">
            <div style="white-space: nowrap">
              <span>{{ dataItem.avgCost | number : 2 : true }}</span>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Total Cost -->
        <ng-container matColumnDef="totalCost">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Total Cost</th>
          <td mat-cell *matCellDef="let dataItem" class="text-end">
            <div style="white-space: nowrap">
              <span>{{ dataItem?.totalCost | number : 2 : true }}</span>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef class="text-end">
            <div style="white-space: nowrap">
              <span>{{ calsPortfolioGridInProgress ? '' : (portfolioData?.totalCost | number : 2 : false) }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Market Rate -->
        <ng-container matColumnDef="marketRate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Market Rate</th>
          <td mat-cell *matCellDef="let dataItem" class="text-end">
            <span>{{ dataItem.marketRate | number : 2 : true }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Market Value -->
        <ng-container matColumnDef="marketValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Market Value</th>
          <td mat-cell *matCellDef="let dataItem" class="text-end">
            <span>{{ dataItem.marketValue | number : 2 : true }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef class="text-end">
            <span>{{ calsPortfolioGridInProgress ? '' : (portfolioData.marketValueTotal | number : 2 : false) }}</span>
          </td>
        </ng-container>

        <!-- Unrealized Gain -->
        <ng-container matColumnDef="unrealizedGain">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Unrealized Gain</th>
          <td mat-cell *matCellDef="let dataItem" class="text-end">
            <div style="white-space: nowrap">
              <span>{{ dataItem.unrealizedGain | number : 2 : true }}</span>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef class="text-end">
            <div style="white-space: nowrap">
              <span>{{ calsPortfolioGridInProgress ? '' : (portfolioData.unrealizedGainTotal | number : 2 : false) }}</span>
            </div>
          </td>
        </ng-container>

        <!-- % Gain -->
        <ng-container matColumnDef="gainPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">% Gain</th>
          <td mat-cell *matCellDef="let dataItem" class="text-end market-gain">
            <div style="white-space: nowrap">
              <span>{{ dataItem.gainPercentage | number : 2 : true }}</span>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- % Mkt. Value -->
        <ng-container matColumnDef="marketValuePercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">% Mkt. Value</th>
          <td mat-cell *matCellDef="let dataItem" class="text-end">
            <div style="white-space: nowrap">
              <span>{{ dataItem.marketValuePercentage | number : 2 : true }}</span>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef class="text-end">
            <div style="white-space: nowrap">
              <span>100.00</span>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="[
            'instrumentCode',
            'totalStock',
            'saleable',
            'avgCost',
            'totalCost',
            'marketRate',
            'marketValue',
            'unrealizedGain',
            'gainPercentage',
            'marketValuePercentage'
          ]"
        ></tr>
        <tr
          mat-row
          *matRowDef="
            let row;
            columns: [
              'instrumentCode',
              'totalStock',
              'saleable',
              'avgCost',
              'totalCost',
              'marketRate',
              'marketValue',
              'unrealizedGain',
              'gainPercentage',
              'marketValuePercentage'
            ]
          "
        ></tr>
        <tr
          mat-footer-row
          *matFooterRowDef="[
            'instrumentCode',
            'totalStock',
            'saleable',
            'avgCost',
            'totalCost',
            'marketRate',
            'marketValue',
            'unrealizedGain',
            'gainPercentage',
            'marketValuePercentage'
          ]"
        ></tr>
      </table>
      <mat-paginator
        [length]="portfolioPageGrid.total"
        [pageSize]="portfolioPageGrid.pageSize"
        [pageIndex]="portfolioPageGrid.pageIndex"
        [pageSizeOptions]="[5, 10, 25, 50]"
        (page)="portfolioPageGrid.onPaginate($event)"
      ></mat-paginator>
    </div>
    <div *ngIf="dataInProgress && !portfolioPageGrid?.dataSource?.data?.length">
      <div class="loader text-center"></div>
    </div>
    <div *ngIf="portfolioData?.unrealizedGainTotal && !calsPortfolioGridInProgress" class="mb-2 mt-3">
      <div class="row portfolio-totals">
        <div class="col-12 text-end">Realized Gain/Loss <span> : </span>{{ portfolioData?.unrealizedGainTotal | number : 2 : false }}</div>
      </div>
      <button
        class="float-end btn btn-fill mt-1 ws-loading {{ downloadingReport ? 'ws-loading-progress' : '' }}"
        (click)="downloadReport('/account/me/financial/ledger-portfolio/export')"
      >
        Download Report
      </button>
    </div>
  </div>
</div>
